module.exports = __webpack_public_path__ + "static/media/classBaseImg.8ebce767.png";